<legend>{{ 'tkey;dialplanmanagement.admin.group.navlink' | translate }}</legend>

<ziro-text fieldId="name"></ziro-text>
<ziro-group-settings-location fieldId="location"></ziro-group-settings-location>
